"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var _index = _interopRequireDefault(require("./index.style"));
const Header = props => {
  const classes = (0, _index.default)();
  const {
    children,
    className,
    ...others
  } = props;
  return /*#__PURE__*/_react.default.createElement(_core.AppBar, (0, _extends2.default)({}, others, {
    className: (0, _clsx.default)(classes.rootHeader, className)
  }), /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    className: classes.headerContainer
  }, children));
};
var _default = exports.default = Header;